import React from 'react'
import SearchIcon from '@components/icons/search-icon'
import CloseIcon from '@components/icons/close-icon'
import cn from 'classnames'
import { Box, Text } from '@chakra-ui/react'

type SearchProps = {
  className?: string
  searchId?: string
  onSubmit: (e: React.SyntheticEvent) => void
  onClear: (e: React.SyntheticEvent) => void
  onFocus?: (e: React.SyntheticEvent) => void
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  name: string
  value: string
  variant?: 'border' | 'fill'
}

const SearchBox = React.forwardRef<HTMLInputElement, SearchProps>(
  (
    {
      className,
      searchId = 'search',
      variant = 'border',
      value,
      onSubmit,
      onClear,
      onFocus,
      onBlur,
      ...rest
    },
    ref,
  ) => {
    return (
      <form
        className="flex w-2/5 relative rounded-md"
        noValidate
        role="search"
        onSubmit={onSubmit}
      >
        <label htmlFor={searchId} className="flex flex-1 items-center py-0.5">
          <input
            id={searchId}
            className={cn(
              'text-heading outline-none w-full h-[52px] ps-5 md:ps-6 pe-14 md:pe-16 bg-skin-full text-skin-base text-sm lg:text-15px rounded-md transition-all duration-200 focus:border-skin-primary focus:ring-1 focus:ring-skin-form',
              {
                'border border-skin-base': variant === 'border',
                'bg-skin-one': variant === 'fill',
              },
            )}
            style={{ paddingLeft: '1.25rem', paddingRight: '3.5rem' }}
            placeholder={'What are you looking for?'}
            aria-label={searchId}
            autoComplete="off"
            value={value}
            onFocus={onFocus}
            onBlur={onBlur}
            ref={ref}
            {...rest}
          />
        </label>
        {value ? (
          <Box
            as="button"
            right={0}
            type="button"
            onClick={onClear}
            title="Clear search"
            className="outline-none absolute top-0 end-0 w-14 md:w-16 h-full flex items-center justify-center transition duration-200 ease-in-out hover:text-heading focus:outline-none"
          >
            <CloseIcon className="w-[17px] h-[17px] text-skin-base text-opacity-40" />
          </Box>
        ) : (
          //absolute top-0 flex items-center justify-center h-full w-14 md:w-16 ltr:right-0 rtl:left-0 shrink-0 focus:outline-none
          <Text
            as="span"
            right={0}
            className="w-14 md:w-16 h-full absolute top-0 end-0 flex flex-shrink-0 justify-center items-center focus:outline-none"
          >
            <SearchIcon className="w-5 h-5 text-skin-base text-opacity-40" />
          </Text>
        )}
      </form>
    )
  },
)

export default SearchBox

SearchBox.displayName = 'SearchBox'
